import { OrchestrationApi } from "./api";

export const GetServiceConfiguration = async (serviceId: string) => {
    const api = await OrchestrationApi();
    const apiResponse = await api
        .get(`/dashboard-ui/configuration/${serviceId}`)
        .then((result) => {
            return result.data;
        });

    return apiResponse;
};
